import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button } from 'avo-ui'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import { TABLE_EXPORT_POINT_MEMBER } from 'configs/loyalty-program/configTableExportPointMember'
import ModalExportPointMember from './ModalExportPointMember'

export const ExportPointMember = ({
    dataList,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    onChangeDate,
    onExport,
    exportDate,
    isLoading,
    isExporting,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Button
                        title={'Export'}
                        icon={icLinkExternal}
                        type={'outline'}
                        onClick={() => setShowModal({ export: true })}
                    />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_EXPORT_POINT_MEMBER.name}
                columns={TABLE_EXPORT_POINT_MEMBER.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
            {modal?.export && (
                <ModalExportPointMember
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    isLoading={isExporting}
                    onExport={onExport}
                    value={exportDate}
                    onChangeDate={onChangeDate}
                />
            )}
        </div>
    )
}
